import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Table, Tab, Tabs, Button, Row } from 'react-bootstrap';
import Noty from 'noty';
import { Map } from 'immutable';
import { injectIntl } from 'react-intl';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import FileUploadProgress from 'react-fileupload-progress';
import appConfig from '../../appConfig';
import piction from '../../utils/piction';
import Loader from '../ui/Loader';
import UMOMediaView from '../UMOMediaView';
import { SESSION_EXPIRED_MESSAGE } from '../../constants/sessionStateTypes';
import { sessionExpired } from '../../actions/session';
import { addIntlError } from '../../actions/messageDialog';
import MetadataView from '../MetadataView/MetadataView';
import { BASE_CARD_URL, CARD_ATTACHMENT_URL, CARD_COMMENT_URL, CARD_URL } from '../../constants/workspaceCards';
import { toggleFullImageView } from '../../actions/mainUI';
import { disableRightClick } from '../../utils/uiUtils';
import CloseIcon from '../Icons/CloseIcon';
import EditIcon from '../Icons/EditDefaul';
import { DATE_FORMAT, DEFAULT_TIMESTAMP_FORMAT } from '../../constants/session';

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  addIntlError: id => dispatch(addIntlError(id)),
  toggleFullImageViewDispatch:
    (isShown, umoData) => dispatch(toggleFullImageView(isShown, umoData)),
});

Noty.overrideDefaults({
  theme: 'bootstrap-v4',
  layout: 'center',
  closeWith: 'click',
  timeout: 3000,
  progressBar: false,
});

/* eslint-disable react/no-string-refs,react/no-find-dom-node */
class WorkspaceDetailView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      requestError: null,
      umo: null,
      editingDate: false,
      editingDescription: false,
      editingComment: false,
      newComment: '',
      isUploadingFile: false,
      catData: {
        id: props.modalWorkspaceID.id || '',
        name: props.modalWorkspaceID.label || '',
      },
      data: {
        cardId: '',
        description: '',
        dueDate: '',
        card_owner: '',
        created: '',
        last_viewed: '',
        attachments: [],
        comments: [],
      },
      history: [],
    };

    this.userName = props.session.get('username').toUpperCase();
    this.surl = props.session.get('surl');
    this.surlCookie = props.session.get('surlCookie');
    this.token = props.session.get('token');
    this.requestPromise = null;
    this.dateFormat = appConfig.dateFormat || DATE_FORMAT;
    this.onFullImageToggle = this.onFullImageToggle.bind(this);
    this.getCard = this.getCard.bind(this);
    this.getHistory = this.getHistory.bind(this);
    this.updateCard = this.updateCard.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.addDate = this.addDate.bind(this);
    this.updateDate = this.updateDate.bind(this);
    this.editDescription = this.editDescription.bind(this);
    this.updateDescription = this.updateDescription.bind(this);
    this.saveDescription = this.saveDescription.bind(this);
    this.updateNewComment = this.updateNewComment.bind(this);
    this.saveNewComment = this.saveNewComment.bind(this);
    this.editComment = this.editComment.bind(this);
    this.saveComment = this.saveComment.bind(this);
    this.onSaveComment = this.onSaveComment.bind(this);
    this.cancelComment = this.cancelComment.bind(this);
    this.deleteComment = this.deleteComment.bind(this);
    this.deleteAttachment = this.deleteAttachment.bind(this);
    this.displayAttachments = this.displayAttachments.bind(this);
    this.displayComments = this.displayComments.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.deleteCard = this.deleteCard.bind(this);
    this.deleteCardPrompt = this.deleteCardPrompt.bind(this);
  }

  componentDidMount() {
    this.requestPromise = piction.getUMOs(`UMO_ID:"${this.props.umoID}"`, {
      zoomify: 'true',
    })
      .then((res) => {
        if (res.umoList.all[0]) {
          const umo = res.umoList.all[0];
          this.setState({ umo, primaryID: this.props.umoID, isLoading: false });

          this.getCard();
          this.getHistory();
        } else {
          new Noty({ type: 'error', text: this.props.intl.formatMessage({ id: 'umoCardView.getCardError' }) }).show();
          this.closeModal();
          this.setState({ requestError: 'No UMO returned', isLoading: false });
        }
        return res;
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          this.props.dispatch(sessionExpired(err));
        }
        this.setState({ requestError: err, isLoading: false });
        new Noty({ type: 'error', text: this.props.intl.formatMessage({ id: 'umoCardView.getCardError' }) }).show();
        this.closeModal();
        return err;
      });
  }

  componentWillUnmount() {
    if (this.requestPromise) {
      this.requestPromise.cancel();
    }
  }

  onFullImageToggle() {
    const umo = this.state.umo;
    let zoomifyURL = umo.data.z[0];
    // Gross hardcoding of 3D template. Revert after demo.
    if (umo.id === '7092422') {
      zoomifyURL += '&override_template=SYSTEM.TIFF3D&override_suffix=3D';
    }
    const umoData = {
      umo,
      fullSrc: umo.type === 'PHOTO' ? umo.webQuality.url : umo.originalList.all[0]._data.$.h,
      type: umo.type,
      zoomifyURL,
    };
    this.props.toggleFullImageViewDispatch(true, umoData);
  }

  onSaveComment() {
    const val = $(`#comment_edit_${this.state.editingComment}`).val();

    this.saveComment({
      cardid: this.state.data.cardId,
      comid: this.state.editingComment,
      comment: val,
      usernm: this.userName,
    });
  }

  /**
   * Returns A JSON Object of a complete card is returned
   * Creates a new card- in case it doesn't exist
   * */
  getCard() {
    $.get(
      CARD_URL,
      {
        surl: this.surlCookie ? undefined : this.surl,
        catid: this.state.catData.id,
        umoid: this.props.umoID,
        usernm: this.userName,
      })
      .done((data) => {
          // Configure comments
        const comments = data.comlst.map(cmnt => ({
          id: cmnt.comid,
          timestamp: new Date(cmnt.comtm),
          comment: cmnt.comtxt,
          author: cmnt.usernm.toUpperCase(),
          editable: this.props.username.toUpperCase() === cmnt.usernm.toUpperCase(),
          isEdited: cmnt.edited,
        }));

          // Sort comments by id so they appear in order
        comments.sort((a, b) => a.id - b.id);

          // Configure attachments
        const attachments = data.attlst.map(att => ({
          id: att.attid,
          url: BASE_CARD_URL + att.atturl,
          thumb: att.thumburl ? BASE_CARD_URL + att.thumburl : '',
          filename: att.atturl.split('/')
                .slice(-1)[0],
          timestamp: new Date(att.atttm),
        }));

        this.setState({
          data: {
            cardId: data.cardid,
            description: data.description,
            dueDate: data.duedate ? new Date(data.duedate) : null,
            card_owner: data.own_nm.toUpperCase(),
            last_updated: data.cardtm,
            last_viewed: data.usrlastviewed,
            attachments,
            comments: comments.reverse(),
          },
        });
      })
      .fail(() => {
        new Noty({
          type: 'error',
          text: this.props.intl.formatMessage({ id: 'umoCardView.getCardError' }),
        }).show();
      });
  }

  getHistory() {
    return piction.request('BASKET_UMO_HISTORY', { UMO_ID: this.props.umoID }, { useJSON: true })
      .then((res) => {
        if (res && res.poids) this.setState({ history: res.poids });
      });
  }

  /*
  * pass parameters cardid, comment, usernm (and comid – if editing existing comment)
  RETURNS:
  A JSON Object of { "comid": "$comid", "comtm": "$comtm" }
  * */
  saveComment(params) {
    $.post(CARD_COMMENT_URL,
      { surl: this.surlCookie ? undefined : this.surl, csrftoken: this.token, ...params })
      .done(() => {
        this.setState({
          editingDate: false,
          editingDescription: false,
          editingComment: false,
          newComment: '',
        });
        this.getCard();
      })
      .fail(() => {
        new Noty({
          type: 'error',
          text: this.props.intl.formatMessage({ id: 'umoCardView.addCommentError' }),
        }).show();
      });
  }

  /*
  * Update a card description and/or due date
  * pass parameters cardid and (description and/or duedate)
* */
  updateCard(params) {
    $.post(CARD_URL,
      { surl: this.surlCookie ? undefined : this.surl, csrftoken: this.token, ...params })
      .done(() => {
        this.setState({
          editingDate: false,
          editingDescription: false,
          editingComment: false,
          newComment: '',
        });
        this.getCard();
      })
      .fail(() => {
        new Noty({
          type: 'error',
          text: this.props.intl.formatMessage({ id: 'umoCardView.updateCardError' }),
        }).show();
      });
  }

  fileUpload() {
    this.setState({ isUploadingFile: false });
    this.getCard();
  }

  addDate() {
    this.setState({ editingDate: true });
  }

  updateDate(date) {
    this.updateCard(
      {
        cardid: this.state.data.cardId,
        duedate: date ? format(date, 'yyyy-MM-dd') : '',
        description: this.state.data.description,
      });
  }

  editDescription() {
    this.setState({ editingDescription: true });
  }

  updateDescription(e) {
    const data = Object.assign({}, this.state.data);
    data.description = e.target.value || '';
    this.setState({ data });
  }

  saveDescription() {
    this.updateCard(
      {
        cardid: this.state.data.cardId,
        description: this.state.data.description,
        duedate: this.state.data.dueDate ? format(this.state.data.dueDate, 'yyyy-MM-dd') : '',
      });
  }

  updateNewComment(e) {
    this.setState({ newComment: e.target.value });
  }

  saveNewComment() {
    this.saveComment(
      {
        cardid: this.state.data.cardId,
        comment: this.state.newComment,
        usernm: this.props.username,
      });
  }

  editComment(id) {
    this.setState({ editingComment: id });
  }

  cancelComment() {
    this.setState({ editingComment: '' });
  }

  deleteComment(id) {
    let delComm = true;
    const n = new Noty({
      progressBar: true,
      timeout: 4000,
      layout: 'bottomCenter',
      type: 'info',
      text: this.props.intl.formatMessage({ id: 'umoCardView.delCommentUndo' }),
      buttons: [
        Noty.button(this.props.intl.formatMessage({ id: 'umoCardView.undo' }),
          'btn btn-error', () => {
            delComm = false;
            n.close();
          }),
      ],
      callbacks: {
        afterClose: () => {
          if (delComm) {
            $.post(CARD_COMMENT_URL,
              { action: 'DELETE', surl: this.surlCookie ? undefined : this.surl, csrftoken: this.token, cardid: this.state.data.cardId, comid: id, usernm: this.userName })
              .done(() => {
                this.getCard();
              })
              .fail(() => {
                new Noty({
                  type: 'error',
                  text: this.props.intl.formatMessage({ id: 'umoCardView.delCommentError' }),
                  layout: 'center',
                  timeout: 3000,
                  progressBar: false,
                }).show();
              });
          }
        },
      },
    });
    n.show();
  }

  deleteAttachment(id) {
    let delFile = true;
    const n = new Noty({
      progressBar: true,
      timeout: 4000,
      layout: 'bottomCenter',
      type: 'info',
      text: this.props.intl.formatMessage({ id: 'umoCardView.delFileUndo' }),
      buttons: [
        Noty.button(this.props.intl.formatMessage({ id: 'umoCardView.undo' }),
          'btn btn-error', () => {
            delFile = false;
            n.close();
          }),
      ],
      callbacks: {
        afterClose: () => {
          if (delFile) {
            $.post(CARD_ATTACHMENT_URL,
              { action: 'DELETE', surl: this.surlCookie ? undefined : this.surl, csrftoken: this.token, cardid: this.state.data.cardId, attid: id, usernm: this.userName })
            .done(() => { this.getCard(); })
      .fail(() => {
        new Noty({
          type: 'error',
          text: this.props.intl.formatMessage({ id: 'umoCardView.delAttachmentError' }),
          layout: 'center',
          timeout: 3000,
          progressBar: false,
        }).show();
      });
          }
        },
      },
    });
    n.show();
  }

  deleteCardPrompt() {
    // new Noty({ type: 'error', text:  }).show();
    const n = new Noty({
      text: this.props.intl.formatMessage({ id: 'umoCardView.delCardVerify' }),
      buttons: [
        Noty.button(this.props.intl.formatMessage({ id: 'umoCardView.delete' }),
      'btn btn-success', () => { this.deleteCard(); n.close(); }, { id: 'button1', 'data-status': 'ok' }),
        Noty.button(this.props.intl.formatMessage({ id: 'umoCardView.cancel' }),
      'btn btn-error', () => {
        n.close();
      }),
      ],
    });
    n.show();
  }

  deleteCard() {
    $.post(CARD_URL, { action: 'DELETE', surl: this.surlCookie ? undefined : this.surl, csrftoken: this.token, cardid: this.state.data.cardId, usernm: this.userName })
      .done(() => { this.closeModal(); })
      .fail(() => {
        new Noty({ type: 'error', text: this.props.intl.formatMessage({ id: 'umoCardView.delCardError' }) }).show();
      });
  }

  displayAttachments() {
    const lastViewed = new Date(this.state.data.last_viewed);
    return this.state.data.attachments.map((attachment) => {
      let img = '';

      if (attachment.thumb) img = attachment.thumb;
      else {
        const type = attachment.filename.split('.').pop();
        switch (type) {
          case 'pdf':
            img = './images/test/pdf.png';
            break;
          case 'xls':
          case 'xlsx':
            img = './images/test/xls.png';
            break;
          case 'doc':
          case 'docx':
            img = './images/test/doc.png';
            break;
          default:
            img = './images/thumb/img_nothumb.gif';
            break;
        }
      }

      return (
        <div key={attachment.id} className="workspace-detail-view__content-attachments-item">
          <div className="workspace-detail-view__content-attachments-item-wrapper">
            { (this.state.data.card_owner === this.userName) ?
              <Button
                className="workspace-detail-view__content-attachments-item__delete"
                id={attachment.id}
                onClick={() => { this.deleteAttachment(attachment.id); }}
                variant="danger"
                size="sm"
              >
                <CloseIcon
                  width={24}
                  height={24}
                  stroke="#fff"
                  aria-label="Close"
                />
              </Button>
              : null
            }
            <a href={attachment.url} target="_blank" rel="noopener noreferrer">
              <img
                alt="Attached file"
                src={img}
                className="workspace-detail-view__content-attachments-item-img"
                onContextMenu={disableRightClick}
              />
            </a>
          </div>
          <span
            className="workspace-detail-view__content-attachments-item-name"
          >
            {
              lastViewed.valueOf() < attachment.timestamp.valueOf() ?
                  <span className="workspace-detail-view__content-comments-comment--new">
                    <i className="workspace-detail-view__content-comments-comment--new-icon" />
                    {this.props.intl.formatMessage({ id: 'umoCardView.newComment' })}
                  </span>
                  : null
              }
            {attachment.filename}
          </span>
        </div>);
    });
  }

  displayComments() {
    const lastViewed = new Date(this.state.data.last_viewed);
    return this.state.data.comments.map((comment, index) => {
      let com = '';
      if (this.state.editingComment === comment.id) {
        com = (<div
          key={comment.id}
          className="workspace-detail-view__content-comments-comment"
        >
          <textarea
            id={`comment_edit_${comment.id}`}
            className="workspace-detail-view__content-comments-comment-edit"
            defaultValue={comment.comment}
          />
          <Button
            className="workspace-detail-view__content-comments-comment-save"
            onClick={this.onSaveComment}
            variant="default"
            size="sm"
          >
            {this.props.intl.formatMessage({ id: 'umoCardView.save' })}
          </Button>
          <Button
            className="workspace-detail-view__content-comments-comment-save"
            onClick={this.cancelComment}
            variant="default"
            size="sm"
          >
            {this.props.intl.formatMessage({ id: 'umoCardView.cancel' })}
          </Button>
        </div>);
      } else {
        com = (<div
          key={comment.id}
          className={classnames('workspace-detail-view__content-comments-comment',
            { 'workspace-detail-view__content-comments-comment-odd': (index % 2) === 1 }
          )}
        >
          <div className="workspace-detail-view__content-comments-comment-item">
            {comment.comment}
          </div>
          <div
            className={classnames(
              'workspace-detail-view__content-comments-comment-user',
              { 'workspace-detail-view__content-comments-comment-user--editable': (index % 2) === 1 },
            )}
          >
            {
              lastViewed.valueOf() < comment.timestamp.valueOf() ?
                <span className="workspace-detail-view__content-comments-comment--new">
                  <i className="workspace-detail-view__content-comments-comment--new__icon" />
                  {this.props.intl.formatMessage({ id: 'umoCardView.newComment' })}
                </span>
                : null
            }
            <span>
              {this.props.intl.formatMessage(
                { id: 'umoCardView.commentBy' },
                { name: comment.author })}
              { comment.timestamp && format(comment.timestamp, `${this.dateFormat} HH:MM` || DEFAULT_TIMESTAMP_FORMAT) }
            </span>
            {comment.isEdited ?
              <span style={{ fontStyle: 'italic', margin: '0 5px' }}>
                {this.props.intl.formatMessage({ id: 'umoCardView.edited' })}
              </span>
              : ''
            }
            {comment.editable ?
              <button
                onClick={() => { this.editComment(comment.id); }}
                className="workspace-detail-view__content-comments-comment-user-actions"
              >
                <EditIcon width={20} height={20} />
              </button>
              : null}
            { (this.state.data.card_owner === this.userName || comment.editable) ?
              <Button
                onClick={() => { this.deleteComment(comment.id); }}
                className="workspace-detail-view__content-comments-comment-user-actions"
                variant="link"
                size="sm"
              >
                <CloseIcon
                  width={20}
                  height={20}
                  aria-label="Close"
                />
              </Button>
              : null}
          </div>
        </div>);
      }

      return com;
    });
  }

  closeModal() {
    this.props.toggleWorkspaceDetailView(false);
  }

  uploadFormGetter() {
    return new FormData(document.getElementById('uploadForm'));
  }

  uploadForm(onSubmit) {
    return (
      <form id='uploadForm' style={{ marginLeft: '5px' }}>
        <input type="hidden" name="surl" value={this.surlCookie ? undefined : this.surl} />
        <input type="hidden" name="csrftoken" value={this.token} />
        <input type="hidden" name="cardid" value={this.state.data.cardId} />
        <input type="hidden" name="catid" value={this.state.catData.id} />
        <input type="hidden" name="umoid" value={this.props.umoID} />
        <input type="hidden" name="usernm" value={this.userName} />
        <input
          className="workspace-detail-view__content-attachments-new-file workspace-detail-view__content-attachments-new-file__add-icon"
          type="file"
          name='file'/>
        <Button type="button" variant="outline-info" size="sm" onClick={onSubmit}>
        {this.props.intl.formatMessage({ id: 'umoCardView.uploadButton' })}
        </Button>
      </form>
    );
  }

  render() {
    const isRestricted = this.state.umo && this.state.umo.thumbnail && this.state.umo.thumbnail._data.$.restricted === 'T';
    return (
      this.state.isLoading ? <Loader className="umo-detail-view__loader" /> :
      <div className="workspace-detail-view">
        <div className="workspace-detail-view__image">
          <CloseIcon
            stroke="#fff"
            width={32}
            height={32}
            aria-label="Close"
            onClick={() => this.props.toggleWorkspaceDetailView(false)}
            className="workspace-detail-view__close-icon"
          />
          <div className="workspace-detail-view__image-display">
            <div className="workspace-detail-view__media">
              <UMOMediaView umo={this.state.umo} />
            </div>
            { // Allow fullscreen view for photos (web quality) or documents/records (html view)
              !isRestricted && ((this.state.umo.type === 'PHOTO' && this.state.umo.webQuality)
                || (!['PHOTO', 'AUDIO', 'VIDEO'].includes(this.state.umo.type) && this.state.umo.originalList.all[0] &&
                  this.state.umo.originalList.all[0]._data.$.h)) ? (
              <div>
                <button
                  onClick={this.onFullImageToggle}
                  className="workspace-detail-view__image-display-fullscreen-button"
                />
              </div>
                ) : null}
          </div>
        </div>
        <div className="workspace-detail-view__body">
          <div className="workspace-detail-view__content">
            <div className="workspace-detail-view__content-title">
              {this.state.umo.name}
            </div>
            <div className="workspace-detail-view__content-sub-title">
              {this.props.intl.formatMessage(
                  { id: 'umoCardView.inCategory' },
                  { catName: this.state.catData.name }
                  )}
            </div>
            { this.state.data.card_owner === this.userName ?
              <Button
                className="workspace-detail-view__content-delete-button"
                onClick={this.deleteCardPrompt}
                variant="danger"
                size="sm"
              >
                <i className="workspace-detail-view__content-delete-button-icon" />
                {this.props.intl.formatMessage({ id: 'umoCardView.deleteCard' })}
              </Button>
              : null
              }
            <Tabs defaultActiveKey={1} id="workspace-detail-view__content-tabs" as="ul">
              <Tab eventKey={1} title={this.props.intl.formatMessage({ id: 'umoCardView.tabGeneral' })}>
                <div className="workspace-detail-view__content-date">
                  <span className="workspace-detail-view__content-date-title">
                    <i />
                    {this.props.intl.formatMessage({ id: 'umoCardView.dueDate' })}
                  </span>
                  <DatePicker
                    className="workspace-detail-view__content-date-edit"
                    isClearable
                    placeholderText={this.dateFormat.toLocaleLowerCase()}
                    value={this.state.data.dueDate ? format(this.state.data.dueDate, this.dateFormat) : ''}
                    onChange={this.updateDate}
                    dateFormat={this.dateFormat}
                    style={{ width: '160px' }}
                    editable={false}
                    onFocus={e => e.target.blur()}
                    minDate={new Date()}
                  />
                  <button
                    type="button"
                    className="react-datepicker__close-icon workspace-detail-view__content-date-remove"
                    aria-label="Close"
                    tabIndex="-1"
                    onClick={() => this.updateDate()}
                  />
                </div>
                {/* fix for demo- task status
                <div className="workspace-detail-view__content-status">
                  <span className="workspace-detail-view__content-status-title">
                    <i />
                    {this.props.intl.formatMessage({ id: 'umoCardView.status' })}
                  </span>
                  <select
                    className="workspace-detail-view__content-select-edit"
                    value={this.state.data.status}
                    onChange={this.updateStatus}
                    style={{ width: '160px' }}
                  >
                    <option />
                    <option>REVISION</option>
                    <option>UNDER REVIEW</option>
                    <option>APPROVED</option>
                    <option>COMPLETED</option>
                  </select>
                </div>*/}
                <div className="workspace-detail-view__content-description">
                  <div className="workspace-detail-view__content-description-title">
                    <i className="workspace-detail-view__content-description-title__icon" />
                    {this.props.intl.formatMessage({ id: 'umoCardView.description' })}
                    <span
                      className="workspace-detail-view__content-description-action"
                      onClick={this.editDescription}
                    >
                      <i className="workspace-detail-view__content-description-action__edit-icon" />
                    </span>
                  </div>
                  {this.state.editingDescription ?
                    <div className="workspace-detail-view__content-description-details">
                      <textarea
                        className="workspace-detail-view__content-description-details-edit"
                        defaultValue={this.state.data.description}
                        onChange={this.updateDescription}
                      />
                      <Button
                        className="workspace-detail-view__content-description-details-save"
                        onClick={this.saveDescription}
                        disabled={_.isEmpty(this.state.data.description)}
                        variant="default"
                        size="sm"
                      >
                        {this.props.intl.formatMessage({ id: 'umoCardView.save' })}
                      </Button>
                    </div>
                  : <div className="workspace-detail-view__content-description-details">
                    {this.state.data.description}
                  </div>
                }
                </div>
                <Row className="workspace-detail-view__content-attachments">
                  <div className="workspace-detail-view__content-attachments-title">
                    <span>
                      <i className="workspace-detail-view__content-attachments-title-icon" />
                      {this.props.intl.formatMessage({ id: 'umoCardView.attachments' })}
                    </span>
                    <FileUploadProgress
                      key={"fileUploader"}
                      url={CARD_ATTACHMENT_URL}
                      method='post'
                      formGetter={this.uploadFormGetter.bind(this)}
                      formRenderer={this.uploadForm.bind(this)}
                      onProgress={(e, request, progress) => {
                        if (!this.state.isUploadingFile) this.setState({ isUploadingFile: true });
                        console.log('progress: ', e, request, progress);
                      }}
                      onLoad={this.fileUpload}
                      onError={(e, request) => {
                        this.setState({ isUploadingFile: false });
                        new Noty({ type: 'error', text: this.props.intl.formatMessage({ id: 'umoCardView.uploadFileError' }) }).show();
                        console.log('error: ', e, request);
                      }}
                      onAbort={() => this.setState({ isUploadingFile: false })}
                      />
                    <span>
                      {this.state.isUploadingFile ?
                        <span className="workspace-detail-view__content-attachments-uploading">
                          <i />
                          {this.props.intl.formatMessage({ id: 'umoCardView.uploading' })}
                        </span>
                      : null}
                    </span>
                  </div>
                  <Row className="workspace-detail-view__content-attachments-row">
                    {this.state.data.attachments.length > 0 ? this.displayAttachments() :
                      this.props.intl.formatMessage({ id: 'umoCardView.noAttachments' })}
                  </Row>
                </Row>
              </Tab>
              <Tab eventKey={2} title={this.props.intl.formatMessage({ id: 'umoCardView.tabComments' })}>
                <div className="workspace-detail-view__content-comments">
                  {/* <div className="workspace-detail-view__content-comments-title">
                      <span>
                        <i />
                        {this.props.intl.formatMessage({ id: 'umoCardView.comments' })}
                      </span>
                    </div>*/}
                  <div className="workspace-detail-view__content-comments-comment-new">
                    <div className="workspace-detail-view__content-comments-comment-new-title">
                      <i />
                      {this.props.intl.formatMessage({ id: 'umoCardView.addComment' })}
                    </div>
                    <textarea
                      className="workspace-detail-view__content-comments-comment-new-entry"
                      placeholder={this.props.intl.formatMessage({ id: 'umoCardView.addComment' })}
                      value={this.state.newComment}
                      onChange={this.updateNewComment}
                    />
                    <Button
                      onClick={this.saveNewComment}
                      className="workspace-detail-view__content-comments-comment-new-submit"
                      variant="primary"
                      size="sm"
                    >
                      {this.props.intl.formatMessage({ id: 'umoCardView.submit' })}
                    </Button>
                  </div>
                  {this.displayComments()}
                </div>
              </Tab>
              <Tab eventKey={3} title={this.props.intl.formatMessage({ id: 'umoCardView.tabMetadata' })}>
                <MetadataView
                  umo={this.state.umo}
                  toggleUMODetailView={this.closeModal}
                  dispatch={this.props.dispatch}
                />
              </Tab>
              <Tab eventKey={5} title={this.props.intl.formatMessage({ id: 'umoCardView.tabHistory' })}>
                <div className="workspace-detail-view__content-history">
                  {this.state.history && this.state.history.length > 0 ?
                    <Table>
                      <thead>
                        <tr>
                          <th>{this.props.intl.formatMessage({ id: 'umoCardView.historyID' })}</th>
                          <th>{this.props.intl.formatMessage({ id: 'umoCardView.historyName' })}</th>
                          <th>{this.props.intl.formatMessage({ id: 'umoCardView.historyDetails' })}</th>
                          <th>{this.props.intl.formatMessage({ id: 'umoCardView.historyDate' })}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {_.map(this.state.history, item => (<tr key={item.poid || 0}>
                          <th>{item.poid || 0}</th>
                          <th>{item.prof_details ? item.prof_details.fullname : ''}</th>
                          <th>{(item.user_defined && item.user_defined[1]) ? item.user_defined[1].value : ''}</th>
                          <th>{(item.user_defined && item.user_defined[3]) ? item.user_defined[3].value : ''}</th>
                        </tr>)
                      )}
                      </tbody>
                    </Table>
                    :
                    <p className="workspace-detail-view__content-history-none">
                      {this.props.intl.formatMessage({ id: 'umoCardView.historyNone' })}
                    </p>
                  }
                </div>
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

WorkspaceDetailView.propTypes = {
  session: PropTypes.instanceOf(Map),
  umoID: PropTypes.string,
  toggleWorkspaceDetailView: PropTypes.func.isRequired,
  username: PropTypes.string,
  dispatch: PropTypes.func,
  modalWorkspaceID: PropTypes.instanceOf(Object),
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(WorkspaceDetailView));
